import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "@app/common/app-setting";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { Injectable } from '@angular/core';
import { SearchMerchant } from '@app/models/merchant/SearchMerchant';

@Injectable()
export class MerchantListingEndpoint extends AutharizedEndPointService{
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getmerchantlistingurl: string = 'api/MerchantDashboardReport/GetMerchantListing';
    constructor(http: HttpClient) {
        super(http, '');
        this.http1 = http;
    }

    getUrl(url: string) {
        return this._baseurl + url;
    }
    getMerchantListingDetails(searchMerchantModel:SearchMerchant) {
        return this.http1.post(this.getUrl(this._getmerchantlistingurl), searchMerchantModel,this.AddAuthToken());
    }
    
}


// WEBPACK FOOTER //
// ./src/app/services/merchant/merchant-listing/merchant-listing-endpoint.service.ts